/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StripeDiscountBean', 'model/StripePlanBean', 'model/StripeSubscriptionBean', 'model/StripeSubscriptionItemBean', 'model/StripeTaxRateBean', 'model/SubscriptionMetadataBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StripeDiscountBean'), require('./StripePlanBean'), require('./StripeSubscriptionBean'), require('./StripeSubscriptionItemBean'), require('./StripeTaxRateBean'), require('./SubscriptionMetadataBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.StripeSubscriptionBean = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.StripeDiscountBean, root.BpmbuildDevelopmentappspotcom.StripePlanBean, root.BpmbuildDevelopmentappspotcom.StripeSubscriptionBean, root.BpmbuildDevelopmentappspotcom.StripeSubscriptionItemBean, root.BpmbuildDevelopmentappspotcom.StripeTaxRateBean, root.BpmbuildDevelopmentappspotcom.SubscriptionMetadataBean);
  }
}(this, function(ApiClient, StripeDiscountBean, StripePlanBean, StripeSubscriptionBean, StripeSubscriptionItemBean, StripeTaxRateBean, SubscriptionMetadataBean) {
  'use strict';

  /**
   * The StripeSubscriptionBean model module.
   * @module model/StripeSubscriptionBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeSubscriptionBean</code>.
   * @alias module:model/StripeSubscriptionBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeSubscriptionBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeSubscriptionBean} obj Optional instance to populate.
   * @return {module:model/StripeSubscriptionBean} The populated <code>StripeSubscriptionBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('applicationFeePercent'))
        obj.applicationFeePercent = ApiClient.convertToType(data['applicationFeePercent'], 'String');
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = StripeSubscriptionBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('billingCycleAnchor'))
        obj.billingCycleAnchor = ApiClient.convertToType(data['billingCycleAnchor'], 'Date');
      if (data.hasOwnProperty('billingThresholdsAmount'))
        obj.billingThresholdsAmount = ApiClient.convertToType(data['billingThresholdsAmount'], 'String');
      if (data.hasOwnProperty('billingThresholdsResetBillingCycleAnchor'))
        obj.billingThresholdsResetBillingCycleAnchor = ApiClient.convertToType(data['billingThresholdsResetBillingCycleAnchor'], 'Boolean');
      if (data.hasOwnProperty('cancelAtPeriodEnd'))
        obj.cancelAtPeriodEnd = ApiClient.convertToType(data['cancelAtPeriodEnd'], 'Boolean');
      if (data.hasOwnProperty('canceledAt'))
        obj.canceledAt = ApiClient.convertToType(data['canceledAt'], 'Date');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('collectionMethod'))
        obj.collectionMethod = ApiClient.convertToType(data['collectionMethod'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Date');
      if (data.hasOwnProperty('currentPeriodEnd'))
        obj.currentPeriodEnd = ApiClient.convertToType(data['currentPeriodEnd'], 'Date');
      if (data.hasOwnProperty('currentPeriodStart'))
        obj.currentPeriodStart = ApiClient.convertToType(data['currentPeriodStart'], 'Date');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('daysUntilDue'))
        obj.daysUntilDue = ApiClient.convertToType(data['daysUntilDue'], 'Number');
      if (data.hasOwnProperty('defaultTaxRateId'))
        obj.defaultTaxRateId = ApiClient.convertToType(data['defaultTaxRateId'], [StripeTaxRateBean]);
      if (data.hasOwnProperty('endedAt'))
        obj.endedAt = ApiClient.convertToType(data['endedAt'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('items'))
        obj.items = ApiClient.convertToType(data['items'], [StripeSubscriptionItemBean]);
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('liveMode'))
        obj.liveMode = ApiClient.convertToType(data['liveMode'], 'Boolean');
      if (data.hasOwnProperty('metaData'))
        obj.metaData = SubscriptionMetadataBean.constructFromObject(data['metaData']);
      if (data.hasOwnProperty('quantity'))
        obj.quantity = ApiClient.convertToType(data['quantity'], 'String');
      if (data.hasOwnProperty('start'))
        obj.start = ApiClient.convertToType(data['start'], 'Date');
      if (data.hasOwnProperty('startDate'))
        obj.startDate = ApiClient.convertToType(data['startDate'], 'Date');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('stripeCustomerId'))
        obj.stripeCustomerId = ApiClient.convertToType(data['stripeCustomerId'], 'String');
      if (data.hasOwnProperty('stripeDiscountId'))
        obj.stripeDiscountId = StripeDiscountBean.constructFromObject(data['stripeDiscountId']);
      if (data.hasOwnProperty('stripeInvoiceIdLatest'))
        obj.stripeInvoiceIdLatest = ApiClient.convertToType(data['stripeInvoiceIdLatest'], 'String');
      if (data.hasOwnProperty('stripePaymentMethodId'))
        obj.stripePaymentMethodId = ApiClient.convertToType(data['stripePaymentMethodId'], 'String');
      if (data.hasOwnProperty('stripePlanId'))
        obj.stripePlanId = StripePlanBean.constructFromObject(data['stripePlanId']);
      if (data.hasOwnProperty('stripeSourceId'))
        obj.stripeSourceId = ApiClient.convertToType(data['stripeSourceId'], 'String');
      if (data.hasOwnProperty('stripeSubscriptionId'))
        obj.stripeSubscriptionId = ApiClient.convertToType(data['stripeSubscriptionId'], 'String');
      if (data.hasOwnProperty('stripeType'))
        obj.stripeType = ApiClient.convertToType(data['stripeType'], 'String');
      if (data.hasOwnProperty('trialEnd'))
        obj.trialEnd = ApiClient.convertToType(data['trialEnd'], 'Date');
      if (data.hasOwnProperty('trialStart'))
        obj.trialStart = ApiClient.convertToType(data['trialStart'], 'Date');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} applicationFeePercent
   */
  exports.prototype.applicationFeePercent = undefined;

  /**
   * @member {module:model/StripeSubscriptionBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {Date} billingCycleAnchor
   */
  exports.prototype.billingCycleAnchor = undefined;

  /**
   * @member {String} billingThresholdsAmount
   */
  exports.prototype.billingThresholdsAmount = undefined;

  /**
   * @member {Boolean} billingThresholdsResetBillingCycleAnchor
   */
  exports.prototype.billingThresholdsResetBillingCycleAnchor = undefined;

  /**
   * @member {Boolean} cancelAtPeriodEnd
   */
  exports.prototype.cancelAtPeriodEnd = undefined;

  /**
   * @member {Date} canceledAt
   */
  exports.prototype.canceledAt = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} collectionMethod
   */
  exports.prototype.collectionMethod = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {Date} currentPeriodEnd
   */
  exports.prototype.currentPeriodEnd = undefined;

  /**
   * @member {Date} currentPeriodStart
   */
  exports.prototype.currentPeriodStart = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {Number} daysUntilDue
   */
  exports.prototype.daysUntilDue = undefined;

  /**
   * @member {Array.<module:model/StripeTaxRateBean>} defaultTaxRateId
   */
  exports.prototype.defaultTaxRateId = undefined;

  /**
   * @member {String} endedAt
   */
  exports.prototype.endedAt = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Array.<module:model/StripeSubscriptionItemBean>} items
   */
  exports.prototype.items = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {Boolean} liveMode
   */
  exports.prototype.liveMode = undefined;

  /**
   * @member {module:model/SubscriptionMetadataBean} metaData
   */
  exports.prototype.metaData = undefined;

  /**
   * @member {String} quantity
   */
  exports.prototype.quantity = undefined;

  /**
   * @member {Date} start
   */
  exports.prototype.start = undefined;

  /**
   * @member {Date} startDate
   */
  exports.prototype.startDate = undefined;

  /**
   * @member {String} status
   */
  exports.prototype.status = undefined;

  /**
   * @member {String} stripeCustomerId
   */
  exports.prototype.stripeCustomerId = undefined;

  /**
   * @member {module:model/StripeDiscountBean} stripeDiscountId
   */
  exports.prototype.stripeDiscountId = undefined;

  /**
   * @member {String} stripeInvoiceIdLatest
   */
  exports.prototype.stripeInvoiceIdLatest = undefined;

  /**
   * @member {String} stripePaymentMethodId
   */
  exports.prototype.stripePaymentMethodId = undefined;

  /**
   * @member {module:model/StripePlanBean} stripePlanId
   */
  exports.prototype.stripePlanId = undefined;

  /**
   * @member {String} stripeSourceId
   */
  exports.prototype.stripeSourceId = undefined;

  /**
   * @member {String} stripeSubscriptionId
   */
  exports.prototype.stripeSubscriptionId = undefined;

  /**
   * @member {String} stripeType
   */
  exports.prototype.stripeType = undefined;

  /**
   * @member {Date} trialEnd
   */
  exports.prototype.trialEnd = undefined;

  /**
   * @member {Date} trialStart
   */
  exports.prototype.trialStart = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/StripeSubscriptionBean.js